// APPLICATIONS WIDE ALERTS
export const SET_ERROR_ALERTS = 'SET_ERROR_ALERTS';
export const SET_SUCCESS_ALERTS = 'SET_SUCCESS_ALERTS';
export const DISCARD_ALERT = 'DISCARD_ALERT';
